import axios, { AxiosResponse } from 'axios';

const ActiveDirectory = {
	async getClaimConsultants(groupName): Promise<ClaimConsultant[]> {
		const response: AxiosResponse = await axios({
			method: 'GET',
			url: process.env.VUE_APP_ADS_SERVICE + '/active-directory/users',
		});

		return Array.isArray(response.data)
			? response.data.map(
					item =>
						new ClaimConsultant(
							item.displayName,
							item.mail,
							item.businessPhones,
							item.givenName,
							item.surname,
						),
			  )
			: [];
	},
};
export class ClaimConsultant {
	public displayName: string;
	public givenName: string;
	public surName: string;
	public email: string;
	public businessPhones: string[];
	constructor(displayName, email, businessPhones, givenName, surName) {
		this.displayName = displayName;
		this.email = email;
		this.businessPhones = businessPhones;
		this.givenName = givenName;
		this.surName = surName;
	}
}
export default ActiveDirectory;
